import Spin from 'antd/es/spin';

export default Spin;
